import { Product, RestaurantDetails } from 'components/common/types'
import {
  RESTAURANT_DETAILS_REQUEST,
  RESTAURANT_DETAILS_SUCCESS,
  RESTAURANT_DETAILS_FAILURE,
  RESTAURANT_LIST_ITEMS
} from '../constants'

type IRestaurantDetailsReducer = {
  data: RestaurantDetails | null
  products: Product[]
  slicedShownItems: {
    name: string
    count: number
    products: Product[]
  }[]
  slicedDropdownItems: {
    name: string
    count: number
    products: Product[]
  }[]
  isLoading: boolean
  error: string
}

const initialState = {
  data: null,
  products: [],
  slicedShownItems: [],
  slicedDropdownItems: [],
  isLoading: true,
  error: ''
}

const RestaurantDetailsReducer = (
  state: IRestaurantDetailsReducer = initialState,
  action
): IRestaurantDetailsReducer => {
  switch (action.type) {
    case RESTAURANT_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true
      }

    case RESTAURANT_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.details,
        products: action.payload.products,
        isLoading: false,
        error: null
      }

    case RESTAURANT_LIST_ITEMS:
      return {
        ...state,
        slicedShownItems: action.payload.slicedShownItems,
        slicedDropdownItems: action.payload.slicedDropdownItems
      }

    case RESTAURANT_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: action.payload }

    default:
      return state
  }
}

export default RestaurantDetailsReducer
